export default __webpack_public_path__ + "static/media/info-img7.f1e4cf31.png";